import React, { ReactNode } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserSizeProvider } from './BrowserSize';
import { NetworkRoleProvider } from './NetworkRole';
import { UnsavedChangesWarningProvider } from './UnsavedChangesWarning';
import { FeatureFlagsProvider } from './FeatureFlags';
import { CurrentUserProvider } from './CurrentUser';
import { ExperimentationProvider } from './Experimentation';
import { ReactQueryProvider } from './ReactQuery';
import { QuickUploadFileProvider } from './QuickUploadFile';

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <HelmetProvider>
      <ReactQueryProvider>
        <CurrentUserProvider>
          <ExperimentationProvider>
            <FeatureFlagsProvider>
              <UnsavedChangesWarningProvider>
                <NetworkRoleProvider>
                  <BrowserSizeProvider>
                    <QuickUploadFileProvider>
                      {children}
                    </QuickUploadFileProvider>
                  </BrowserSizeProvider>
                </NetworkRoleProvider>
              </UnsavedChangesWarningProvider>
            </FeatureFlagsProvider>
          </ExperimentationProvider>
        </CurrentUserProvider>
      </ReactQueryProvider>
    </HelmetProvider>
  );
}
